import {analyticsLogEvent} from '../api'

const eventName = 'wishlist'
const eventCategory = 'Wish List'

interface Parameters {
    action: 'add' | 'remove'
    label: string
}

/**
 * Tracks a wishlist event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventNewsletterAction} params.action - Action of the event.
 * @param {string} params.label - Label of the event.
 */
export function analyticsEventWishlist({action, label}: Parameters): void {
    const eventDetails = {
        eventCategory: eventCategory,
        eventAction: action,
        eventLabel: label,
    }

    analyticsLogEvent(eventName, eventDetails)
}
